import axios from "axios";

export default {
  getNotifications(context) {
    axios.get("notifications").then((res) => {
      context.commit("setNotifications", res.data.data);
      context.commit("setUnread", res.data.unread_count);
    });
  },
};
